/**
 * Navigation Hider
 * Hides shop navigation (Men, Women, Brands, Sale, etc.) from unauthorized visitors
 * Only shows navigation to visitors with valid campaign + token
 */

class NavigationHider {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.checkAndHideNavigation());
    } else {
      this.checkAndHideNavigation();
    }
  }

  checkAndHideNavigation() {
    // Wait for UTM Tracker to initialize
    const checkAccess = () => {
      const tracker = window.UTMTracker;
      
      if (!tracker) {
        // Tracker not loaded yet, try again
        setTimeout(checkAccess, 50);
        return;
      }
      
      // Check if user has a valid token (token alone is sufficient for navigation)
      const hasValidToken = tracker.getStoredAccessToken() !== null;
      
      // Also check URL for token parameter directly (in case storage hasn't synced yet)
      const urlParams = new URLSearchParams(window.location.search);
      const urlToken = urlParams.get('token') || urlParams.get('access_token');
      const hasUrlToken = urlToken && tracker.VALID_TOKENS && tracker.VALID_TOKENS.includes(urlToken);
      
      const hasAccess = hasValidToken || hasUrlToken;
      
      if (!hasAccess) {
        console.log('🔒 Hiding navigation - No valid access token');
        this.hideNavigation();
        // Don't show header message - gate overlay is enough
      } else {
        console.log('✅ Showing navigation - Valid token detected');
        this.showNavigation();
      }
    };
    
    checkAccess();
  }

  /**
   * Hide main navigation for unauthorized users
   */
  hideNavigation() {
    // Hide desktop navigation
    const desktopNav = document.querySelector('.header__inline-menu');
    if (desktopNav) {
      desktopNav.style.display = 'none';
    }
    
    // Hide mobile menu drawer button
    const mobileMenuButton = document.querySelector('header-drawer');
    if (mobileMenuButton) {
      mobileMenuButton.style.display = 'none';
    }
    
    // Hide menu drawer content
    const menuDrawer = document.querySelector('.menu-drawer-container');
    if (menuDrawer) {
      menuDrawer.style.display = 'none';
    }
    
    // Hide specific menu items by class
    document.querySelectorAll('.header__menu-item, .list-menu__item').forEach(item => {
      // Keep logo and search, hide everything else
      if (!item.closest('.header__heading') && !item.closest('.header__search')) {
        item.style.display = 'none';
      }
    });
    
    // Removed header message - gate overlay is sufficient
  }

  /**
   * Show navigation for authorized users
   */
  showNavigation() {
    // Show desktop navigation
    const desktopNav = document.querySelector('.header__inline-menu');
    if (desktopNav) {
      desktopNav.style.display = '';
    }
    
    // Show mobile menu button
    const mobileMenuButton = document.querySelector('header-drawer');
    if (mobileMenuButton) {
      mobileMenuButton.style.display = '';
    }
    
    // Show menu drawer
    const menuDrawer = document.querySelector('.menu-drawer-container');
    if (menuDrawer) {
      menuDrawer.style.display = '';
    }
    
    // Show all menu items
    document.querySelectorAll('.header__menu-item, .list-menu__item').forEach(item => {
      item.style.display = '';
    });
    
    // Header message removed - only gate overlay needed
  }
}

// Initialize navigation hider
const navigationHider = new NavigationHider();

// Expose globally
window.NavigationHider = navigationHider;

